const SETTINGS = {
  // id for portal container (we will dynamically load elements in this element)
  PORTAL_ID: 'ontruck-portal',
  // time between reloads
  RELOAD_CARRIERS_LIST_INTERVAL_IN_SECONDS: 15,
  CARRIERS_LIST_PAGE_SIZE: 25,
  CARRIERS_TABLE_COLUMN_SIZES_IN_PX: {
    NAME: '200px',
    RATING: '200px',
    WORKING_AREAS: '200px',
    EXTERNAL_ID: '200px',
  },
};

export default SETTINGS;
